/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PutAdminConcurrencyRulesByIdParams,
  DeleteAdminConcurrencyRulesByIdParams,
  PutAdminConcurrencyRulesByIdBody,
  PostAdminConcurrencyRulesBody,
  PutAdminConcurrencyRulesByIdResponse,
  DeleteAdminConcurrencyRulesByIdResponse,
  GetAdminConcurrencyRulesResponse,
  PostAdminConcurrencyRulesResponse,
} from '../types';

export class AdminConcurrencyRules extends Controller {
  async putAdminConcurrencyRulesById<
    T extends PutAdminConcurrencyRulesByIdResponse,
    D,
    C extends PutAdminConcurrencyRulesByIdBody
  >(
    body: C,
    { id }: PutAdminConcurrencyRulesByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/admin/concurrency-rules/${id}`,
      body,
      axiosConfig
    );
  }

  async deleteAdminConcurrencyRulesById<
    T extends DeleteAdminConcurrencyRulesByIdResponse,
    D,
    C extends null
  >(
    { id }: DeleteAdminConcurrencyRulesByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/admin/concurrency-rules/${id}`,
      { ...axiosConfig, data: body }
    );
  }

  async getAdminConcurrencyRules<
    T extends GetAdminConcurrencyRulesResponse,
    D,
    C
  >(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/admin/concurrency-rules',
      axiosConfig
    );
  }

  async postAdminConcurrencyRules<
    T extends PostAdminConcurrencyRulesResponse,
    D,
    C extends PostAdminConcurrencyRulesBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/admin/concurrency-rules',
      body,
      axiosConfig
    );
  }
}
